<template>
  <div class="v-btn">
    <div class="icon-box bg-yellow">
      <i v-if="fileUrl.length ===0" class="icon-file"></i>
      <img v-else :src="fileUrl" style="width: 80px" alt="">
    </div>
    <div class="btn-description">
      <div class="btn-header">
        {{city}}
        <small class="d-block">File Size : {{fileSize===''?'0KB':fileSize}}</small>
        <v-btn class="upload-btn">
          <input @change="cityPlatBrowse($event,city)" style="display:none" type="file" :id="`city_plat_${city.replace(' ','_')}`">
          <label :for="`city_plat_${city.replace(' ','_')}`">
            <i class="icon-upload">
              <span class="path2"></span>
            </i>
            Upload
          </label>
        </v-btn>
      </div>
      <v-progress-linear
        color="red darken-2"
        :query="true"
        :value="progressValue"
      ></v-progress-linear>
    </div>
  </div>
</template>

<script>
import { MWS_FILE_SIZE } from '../../Helper'
import Parse from 'parse'
import { mapActions } from 'vuex'

export default {
  name: 'CityPlatUpload',
  data () {
    return {
      fileSize: '',
      fileName: '',
      fileUrl: '',
      progressValue: 0
    }
  },
  props: {
    city: {
      type: String,
      defaults: ''
    }
  },
  methods: {
    ...mapActions(['showToast']),
    cityPlatBrowse (file, city) {
      const cityNoSpace = city.replace(' ', '_')
      file = document.getElementById(`city_plat_${cityNoSpace}`)
      const fileInput = file.files[0]
      console.log(fileInput)

      const reader = new FileReader()
      reader.readAsDataURL(fileInput)
      reader.onload = () => {
        const data = {
          base64: (reader.result).toString('base64')
        }

        const timestamp = ((new Date().getTime()) / 1000).toFixed(0)
        const name = `city_${cityNoSpace}_${timestamp}`
        const parseFile = new Parse.File(name, data)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')
        parseFile
          .save({
            progress: (value) => {
              this.progressValue = value * 100
            }
          })
          .then(() => {
            this.fileName = parseFile._name
            this.fileUrl = parseFile._url
            this.fileSize = MWS_FILE_SIZE(fileInput.size)
            const data = {
              cityName: city,
              fileName: this.fileName,
              fileUrl: this.fileUrl
            }
            this.$emit('cityPlatUploadSubmit', data)
            this.showToast({
              isOpen: true,
              text: 'Image Upload successfully..',
              timeout: 2000
            })
          })
          .catch(console.log)
      }
      reader.onerror = error => {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>

</style>
